import { BCMSRecord, useGlobalController, useParams, Workflow } from "@bcm-dev/bcms-vite";
import { Bill, Biller } from "model";

import EditBillerDetailsPage from "compid/pages/EditBillerDetailsPage";

const steps = {
    "/editBillerDetails" : <EditBillerDetailsPage />
};

/**
 * @function EditBillerWorkflow
 * @returns {React.Component}
 * @description The main workflow component for the edit biller workflow
 * @example
 * <EditBillerWorkflow />
 */
export default function EditBillerWorkflow() {
    // Initalize a global controller instance
    const controller = useGlobalController();
    // Grab the billerID from the parameters
    const { billerID } = useParams();
    // Get the default value for the workflow
    const value = getDefaultEdit(controller, billerID);
    return <Workflow value={ value } steps={ Object.values(steps) } />
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Returns the steps of the workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultEdit
 * @param {bcmsController} controller - A global controller instance
 * @param {STRING} billerID - The biller id of the biller that should be shown
 * @returns {OBJECT}
 * @description Creates the default value for the workflow
 */
export const getDefaultEdit = (controller, billerID) => {
    BCMSRecord.globalControllerFor([ Biller, Bill ], controller);
    const biller = billerID === undefined ? Biller.firstInstanceOf() : Biller.initByID(billerID);

    return { biller };
};